import { enGB } from 'date-fns/locale/en-GB'
import { ru } from 'date-fns/locale/ru'

import { daysOfWeekKyrgyz } from '../lib/getLocaleDates'

export const localeKg = {
  ...ru,
  localize: {
    ...ru.localize,
    day: (n: number) => daysOfWeekKyrgyz[n] as string,
  },
  formatLong: {
    ...ru.formatLong,
  },
}

export type ILocales = 'en' | 'ru' | 'ky'

export const DATE_LOCALES = {
  ky: localeKg,
  en: enGB,
  ru: ru,
}
